import React from "react";
import ReactDOM from "react-dom";
import { compose } from "redux";
import { Provider } from "react-redux";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import PropTypes from "prop-types";
import { setProjectTitle } from "../reducers/project-title";
import { setUserId, setProjectLink, setProjectId } from "../reducers/custom.js"

import AppStateHOC from "../lib/app-state-hoc.jsx";
import GUI from "../containers/gui.jsx";
import HashParserHOC from "../lib/hash-parser-hoc.jsx";
import SBFileUploaderHOC from "../lib/sb-file-uploader-hoc.jsx";
import log from "../lib/log.js";
import { API_PATH, LOGIN_APP_PATH, API_PATH_UPLOAD } from "../constants.js";

export function urlToFile(url) {
    return fetch(url, {
        mode: "cors",
        headers: {
            Accept: "*/*",
        },
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`Failed to fetch file: ${response.statusText}`);
            }
            return response.blob();
        })
        .then((blob) => {
            const fileName = url
                .substring(url.lastIndexOf("/") + 1)
                .split("-")
                .slice(1)
                .join("-")
                .replace(".sb3", "");
            console.log("Creating file from blob:", fileName, blob);
            return new File([blob], fileName, {
                type: "application/x.scratch.sb3",
            });
        })
        .catch((error) => {
            console.error("Error converting URL to file:", error);
            throw error;
        });
}

export function detDataById(id) {
    return fetch(`${API_PATH}/auth/getUserByIdVizz?id=${id}`, {
        mode: "cors",
        headers: {
            Accept: "*/*",
        },
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`Failed to fetch file: ${response.statusText}`);
            }
            return response.json();
        })
        .catch((error) => {
            console.error("Error converting URL to file:", error);
            throw error;
        });
}

const onClickLogo = () => {
    window.location = "https://controla.in";
};

const handleTelemetryModalCancel = () => {
    log("User canceled telemetry modal");
};

const handleTelemetryModalOptIn = () => {
    log("User opted into telemetry");
};

const handleTelemetryModalOptOut = () => {
    log("User opted out of telemetry");
};

const removeQueryParam = (param) => {
    const url = new URL(window.location);
    url.searchParams.delete(param);
    window.history.replaceState({}, "", url);
};

const isValidToken = (token) => {
    return token && token.split(".").length === 3;
};

/*
 * Render the GUI playground. This is a separate function because importing anything
 * that instantiates the VM causes unsupported browsers to crash
 * {object} appTarget - the DOM element to render to
 */
export default (appTarget) => {
    GUI.setAppElement(appTarget);

    const WrappedGui = compose(AppStateHOC, HashParserHOC)(GUI);

    class ProjectLoader extends React.Component {
        componentDidMount() {
            const queryParams = new URLSearchParams(window.location.search);
            const link = queryParams.get("link");
            const id = queryParams.get("id");
            const projectId = queryParams.get('projectId');
            const studentId = queryParams.get('studentId');

            this.checkForSubdomainChange();
        // Add event listeners for subdomain changes when route changes
        window.addEventListener('popstate', this.checkForSubdomainChange);
        window.addEventListener('hashchange', this.checkForSubdomainChange);

            if (link) {
                localStorage.setItem("link", decodeURIComponent(link));
            }
            
            if (projectId) {
                localStorage.setItem("projectId", projectId);
            }

            if (studentId) {
                localStorage.setItem("studentId", studentId);
            }
            

            if (link || localStorage.getItem("link")) {
                // if(link) {
                //     console.log(decodeURIComponent(link))
                // } else {
                //     console.log(localStorage.getItem("link"))
                // }
                const decodedLink = link ?  decodeURIComponent(link) : localStorage.getItem("link");
                console.log("Loading file from link:", API_PATH_UPLOAD, decodedLink);

              setTimeout(() => {
                removeQueryParam("id");
                urlToFile(`${API_PATH_UPLOAD}${decodedLink}`)
                .then((file) => {
                    console.log("File created, attempting upload");
                    console.log("Props available:", this.props);
                    if (this.props.onStartSelectingFileUpload) {
                        // setTimeout(() => {
                            this.props.onStartSelectingFileUpload(file);
                        // }, 1000);

                        // Listen for project load completion
                        const handleProjectLoaded = () => {
                            console.log(
                                "Project loaded, setting title to:",
                                file.name
                            );
                            if (this.props.onSetProjectTitle && this.props.onSetUserId) {
                                this.props.onSetProjectTitle(file.name);
                                this.props.onSetUserId(id || localStorage.getItem("id"))
                                removeQueryParam("id");
                            }

                            if(decodedLink && this.props.onSetProjectLink) {
                                this.props.onSetProjectLink(decodedLink || decodeURIComponent(localStorage.getItem("link")))
                                removeQueryParam("link");
                            }

                            if(projectId && this.props.onSetProjectId) {
                                this.props.onSetProjectId(projectId || localStorage.getItem("projectId"))
                                removeQueryParam("projectId");
                                removeQueryParam("studentId");
                            }
                            // Remove the listener after it's called
                            this.props.vm.removeListener(
                                "workspaceUpdate",
                                handleProjectLoaded
                            );
                        };

                        // Add listener for project load completion
                        this.props.vm.on(
                            "workspaceUpdate",
                            handleProjectLoaded
                        );
                    } else {
                        console.error(
                            "onStartSelectingFileUpload is not available"
                        );
                    }
                })
                .catch((error) => {
                    console.error("Failed to load project:", error);
                });
              }, 3000)

                setTimeout(() => {
                    const url = decodeURIComponent(link);
                    const projectName = url
                        .substring(url.lastIndexOf("/") + 1)
                        .split("-")
                        .slice(1)
                        .join("-")
                        .replace(".sb3", "");
                    this.props.onSetProjectTitle(projectName);
                }, 1000);
            }
            if(localStorage.getItem("id")) {           
                detDataById(localStorage.getItem("id")).then((data) => {
                    if (data?.data?.is_login != 1) {
                        localStorage.clear();
                        window.location.replace(
                            `${LOGIN_APP_PATH}?logout=true`
                        );
                    } else {
                        this.props.onSetUserId(id)
                        removeQueryParam("token");
                        removeQueryParam("role");
                        // removeQueryParam("id");
                    }
                }).catch(e => {
                    localStorage.clear();
                        window.location.replace(
                            `${LOGIN_APP_PATH}?logout=true`
                        );
                });
            } else {
                localStorage.clear()
                window.location.replace(`${LOGIN_APP_PATH}?logout=true`);
            }

            

            
        }

        // componentDidUpdate(prevProps) {
        //     // You can also use this method to check on route changes
        //     if (this.props.location !== prevProps.location) {
        //         this.checkForSubdomainChange();
        //     }
        // }
    
        // componentWillUnmount() {
        //     // Cleanup event listeners to prevent memory leaks
        //     window.removeEventListener('popstate', this.checkForSubdomainChange);
        //     window.removeEventListener('hashchange', this.checkForSubdomainChange);
        // }
    
        checkForSubdomainChange = () => {
            const currentSubdomain = window.location.hostname.split('.')[0];
    
            if (currentSubdomain === 'expectedSubdomain') {
                console.log('User is on the expected subdomain');
            } else {
                console.log('User is on a different subdomain');
            }
        }

        render() {
            // Only pass GUI-specific props to WrappedGui
            const {
                onStartSelectingFileUpload,
                onSetProjectTitle,
                vm,
                projectChanged,
                dispatch,
                ...guiProps
            } = this.props;

            return <WrappedGui {...guiProps} canEditTitle={true} />;
        }
    }

    // Add PropTypes
    ProjectLoader.propTypes = {
        onStartSelectingFileUpload: PropTypes.func,
        onSetProjectTitle: PropTypes.func,
        projectChanged: PropTypes.bool,
        onSetUserId: PropTypes.func,
        onSetProjectLink: PropTypes.func,
        vm: PropTypes.shape({
            on: PropTypes.func,
            removeListener: PropTypes.func,
        }),
    };

    // Add mapStateToProps for ProjectLoader
    const mapStateToProps = (state) => ({
        vm: state.scratchGui.vm,
        projectChanged: state.scratchGui.projectChanged
    });

    // Add mapDispatchToProps for ProjectLoader
    const mapDispatchToProps = (dispatch) => ({
        onSetProjectTitle: (title) => {
            console.log("Dispatching setProjectTitle with:", title);
            dispatch(setProjectTitle(title));
        },
        onSetUserId: (userId) => {
            dispatch(setUserId(userId));
        },
        onSetProjectLink: (link) => {
            dispatch(setProjectLink(link));
        },
        onSetProjectId:  (projectId) => {
            dispatch(setProjectId(projectId));
        },
    });

    // Wrap ProjectLoader with necessary HOCs including connect
    const WrappedProjectLoader = compose(
        AppStateHOC,
        SBFileUploaderHOC,
        connect(mapStateToProps, mapDispatchToProps)
    )(ProjectLoader);

    // TODO a hack for testing the backpack, allow backpack host to be set by url param
    const backpackHostMatches = window.location.href.match(
        /[?&]backpack_host=([^&]*)&?/
    );
    const backpackHost = backpackHostMatches ? backpackHostMatches[1] : null;

    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
    const role = queryParams.get("role");
    const id = queryParams.get("id");
    // const projectId = queryParams.get('projectId');
    // const link = queryParams.get('link');

    const localToken = window.localStorage.getItem("token");
    const localRole = window.localStorage.getItem("role");
    const localId = window.localStorage.getItem("id");

    const isTokenVerified = isValidToken(token) || isValidToken(localToken);

    if (isTokenVerified) {
        window.localStorage.setItem("token", token ? token : localToken);
        window.localStorage.setItem("role", role ? role : localRole);
        window.localStorage.setItem("id", (id != "undefined" && id) ? id : localId);
        // if(projectId && link) {
        //     window.localStorage.setItem("project", JSON.stringify({id:projectId, link: link}));
        // }
    }

    const scratchDesktopMatches = window.location.href.match(
        /[?&]isScratchDesktop=([^&]+)/
    );
    let simulateScratchDesktop;
    if (scratchDesktopMatches) {
        try {
            simulateScratchDesktop = JSON.parse(scratchDesktopMatches[1]);
        } catch {
            simulateScratchDesktop = scratchDesktopMatches[1];
        }
    }

    // if (process.env.NODE_ENV === "production" && typeof window === "object") {
    //     // Warn before navigating away
    //     window.onbeforeunload = () => true;
    // }

    const wrappedGuiProps = {
        canEditTitle: true,
        backpackVisible: !simulateScratchDesktop,
        showComingSoon: !simulateScratchDesktop,
        backpackHost: backpackHost,
        canSave: false,
        onClickLogo: onClickLogo,
    };

    if (simulateScratchDesktop) {
        Object.assign(wrappedGuiProps, {
            isScratchDesktop: true,
            showTelemetryModal: true,
            canSave: false,
            onTelemetryModalCancel: handleTelemetryModalCancel,
            onTelemetryModalOptIn: handleTelemetryModalOptIn,
            onTelemetryModalOptOut: handleTelemetryModalOptOut,
        });
    }

    ReactDOM.render(<WrappedProjectLoader {...wrappedGuiProps} />, appTarget);
};
